import {
  RU_POSTFIX_REGEX,
  CHANGED_CATEGORIES_SLUGS,
} from '@monoimin/constants';

import type { DataSourceEntry } from '@monoimin/sb-types';

export type ArticlePageType = 'imin-blog' | 'imin-insider' | 'golden-visa';

export type ChangedCategories = keyof typeof CHANGED_CATEGORIES_SLUGS;

export type ChangedSlugs =
  keyof (typeof CHANGED_CATEGORIES_SLUGS)[ChangedCategories];

export function getDatasourceByValue(
  datasource?: DataSourceEntry[],
  currentSlug?: string,
  pageType?: ArticlePageType
): DataSourceEntry | undefined {
  return datasource?.find((el) => {
    const type = pageType || el.type;
    const value = el.value;

    const legacySlug =
      CHANGED_CATEGORIES_SLUGS[type as ChangedCategories]?.[
        value as ChangedSlugs
      ] || '';

    const valueWithoutPostfix = value?.replace(RU_POSTFIX_REGEX, '');

    const currentSlugWithoutType = currentSlug?.replace(`${type}-`, '');

    return (
      legacySlug === currentSlugWithoutType ||
      value === currentSlugWithoutType ||
      valueWithoutPostfix === currentSlugWithoutType ||
      el.dimension_value === currentSlug
    );
  });
}

export default getDatasourceByValue;
